import { createFileRoute } from "@tanstack/react-router";
import { OwnResident } from "@/components/app/portal/pages/own-resident";
import { ResidentHomePage } from "@/components/app/portal/pages/resident-home-page";

export const Route = createFileRoute("/resident-portal/")({
  head: () => ({ meta: [{ title: "Your portal | People AI" }] }),
  component: ResidentHome,
});

/** A resident's own portal: their record, the one the login was made for. */
function ResidentHome() {
  return <OwnResident>{(own) => <ResidentHomePage own={own} />}</OwnResident>;
}
